module.exports = __webpack_public_path__ + "static/media/ComingSoon.487290f9.png";